// extracted by mini-css-extract-plugin
export default {"devices":"styles_devices__mV+DU"};